export default {
  mounted(el, binding) {
    const delay = binding.value || 5000; // tempo padrão: 2 segundos
    el.addEventListener("click", () => {
      if (el.disabled) return; // já clicado

      el.disabled = true;
      el.classList.add("opacity-50", "cursor-not-allowed"); // visual opcional

      setTimeout(() => {
        el.disabled = false;
        el.classList.remove("opacity-50", "cursor-not-allowed");
      }, delay);
    });
  },
};
